export default __webpack_public_path__ + "f842127f1bff19fee896a26aba3b5c1d.png";